import { Skeleton, Stack } from '@mui/material';
import React from 'react';
import { CardMediaWrapper, StyledCard } from '../ProductCard.style';
import type { ProductCardType } from '../types';

export interface ProductCardSkeletonProps {
  type?: ProductCardType;
}

const ProductCardSkeleton = (props: ProductCardSkeletonProps) => {
  const { type = 'wide' } = props;

  return (
    <StyledCard elevation={0} type={type}>
      <CardMediaWrapper flexShrink={0} type={type}>
        <Skeleton variant="rounded" width="100%" sx={{ flex: 1, aspectRatio: 1 }} />
      </CardMediaWrapper>

      <Stack direction="column" flex={1} gap="8px">
        <Skeleton variant="text" width="20%" sx={{ fontSize: 12, lineHeight: '32px' }} />
        <Skeleton variant="text" width="100%" sx={{ fontSize: 20 }} />
        <Skeleton variant="rounded" width="100%" height="40px" />
      </Stack>
    </StyledCard>
  );
};

export default ProductCardSkeleton;
